import React, { useState } from "react";
import { Divider, Typography } from "@material-ui/core";
import logoAgent from "../styles/images/logoAgent.png";
import logoAgentApproved from "../styles/images/logoAgentApproved.png";
import logoAdmin from "../styles/images/logoAdmin.png";
import logoImo from "../styles/images/logo-IMO.png";
import logoBank from "../styles/images/logo-Bank.png";
import logoTrustee from "../styles/images/logo-Trustee.png";
import logoCarrier from "../styles/images/logo-Carrier.png";
import logoClient from "../styles/images/logo-ilia.png";
import niwLogo from "../styles/images/niwLogo.png";
import logoilia from "../styles/images/logoilia.png";
import pbg from "../styles/images/pbg.png";
import logoAggregator from "../styles/images/aggregatorLogo.png";
import {
    AccountType,
    LOGO_BASE_URL,
    isServicingAccessible,
    StrategySlugEnum,
    getAgentTypeName,
    AGENT_TYPES, AgentType,
} from "../constants";
import {
    AdminNavigation,
    AgentNavigation,
    AssociationClientNavigation,
    BankNavigation,
    ClientNavigation,
    GroupNavigation,
    ImoNavigation,
    TrusteeNavigation,
    AggregatorNavigation
} from "../components/navigation";
import { useSelector } from "react-redux";
import { RootState } from "../reducers";
import StrategyName from "./client/StrategyName";
import CarrierNavigation from "./navigation/CarrierNavigation";
import { isNfIulCase } from "../utils/commonFunc";
import { history } from "../configureStore";
import { checkIsReviewDetailRoute } from "../pages/clientServicing/utils";

type Props = {
    user: any,
    handleNavClick: Function,
    className: string,
    SetIsEstimation: Function,
    clientPolicy: any
}
export default function CustomNavigation(props: Props) {
    const { user: { company }, SetIsEstimation, clientPolicy} = props;
    const {
        user: { role, accessType, defaultStatergyLogo },
        user
    } = useSelector((state: RootState) => state.auth);
    const client = user && user.client;
    
    const [reBrandLogo, setReBrandLogo] = useState<string>("");
    const [companyLogo, setCompanyLogo] = useState<string>("");
    const [companyName, setCompanyName] = useState<string>("");
    const [strategyName, setStrategyName] = useState<string>("Kai-Zen");
    const [strategyLogo, setStrategyLogo] = useState<any>(defaultStatergyLogo);
    const isApprovedAgent = clientPolicy && clientPolicy.agent && clientPolicy.agent.agentType === AgentType.Approved;
    const isServiceDashboardAccessible = user && user.inviteStatus && isServicingAccessible(user) || false;
    let strategySlug: any = StrategySlugEnum.NfIUL;

    React.useEffect(() => {
        if (client) {
            setStrategyLogo((clientPolicy && clientPolicy.strategy && clientPolicy.strategy.logo) || strategyLogo);
            setStrategyName((clientPolicy && clientPolicy.strategy && clientPolicy.strategy.name) || strategyName);
            strategySlug = (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.slug) || strategySlug;
        } else if (accessType === "client" && (user.role === 1 || user.role === 2 || user.role === 3 || user.role === 4 || user.role === 15)) {
            setStrategyName((user.demoStrategy && user.demoStrategy.name) || strategyName);
            setStrategyLogo((user.demoStrategy && user.demoStrategy.logo) || strategyLogo);
            strategySlug = (user.demoStrategy && user.demoStrategy.slug) || strategySlug;
        }
    }, [client, user]);
    const isNfIul = isNfIulCase((clientPolicy && clientPolicy.strategy && clientPolicy.strategy.id) as number, strategySlug);
    const aggregatorId = user.role === AccountType.Aggregator ? user && user.aggregator && user.aggregator.id : user.role === AccountType.AggregatorMember ? user && user.aggregatorAdditionalMember && user.aggregatorAdditionalMember.aggregatorId : 0;
    React.useEffect(() => {
        // const clientPolicy = clientPolicy;
        if (clientPolicy && clientPolicy.strategy) {
            if (clientPolicy && clientPolicy.imo && clientPolicy.imo.reBrand && clientPolicy.strategy && clientPolicy.strategy.reBrand === 2 && clientPolicy.strategy.reBrandLogo) {
                setReBrandLogo(LOGO_BASE_URL + clientPolicy.strategy.reBrandLogo);
            }
            if (clientPolicy.strategy && clientPolicy.strategy.reBrand === 1 && clientPolicy.strategy.reBrandLogo) {
                setReBrandLogo(LOGO_BASE_URL + clientPolicy.strategy.reBrandLogo);
            }
            if (clientPolicy.agent && clientPolicy.agent.companyLogo) {
                setCompanyLogo(clientPolicy.agent.companyLogo);
            }

            if ((props && props.user && props.user.role === 5) && clientPolicy && clientPolicy.agent && clientPolicy.agent.user) {
                setCompanyName(clientPolicy.agent.companyName);
            } else if (props.user.role === 6 && clientPolicy && clientPolicy.company) {
                setCompanyName(clientPolicy.company.companyName);
                setCompanyLogo(clientPolicy.company.user.image);
            }
        }
        if (props.user.accessType === "client" && user.role === 4) {
            if (user.agent && user.agent.companyLogo) {
                setCompanyLogo(user.agent.companyLogo);
            }
            if (user.agent && user.agent.companyName) {
                setCompanyName(user.agent.companyName);
            }
            if (user.agent && user.agent.imo && user.agent.imo.reBrand && props.user.demoStrategy && props.user.demoStrategy.reBrand === 2 && props.user.demoStrategy.reBrandLogo) {
                setReBrandLogo(LOGO_BASE_URL + props.user.demoStrategy.reBrandLogo);
            }
            if (props.user && props.user.demoStrategy && props.user.demoStrategy.reBrand === 1 && props.user.demoStrategy.reBrandLogo) {
                setReBrandLogo(LOGO_BASE_URL + props.user.demoStrategy.reBrandLogo);
            }
        }
        if (props.user.accessType === "client" && (user.role === 3 || user.role === 15)) {
            if (clientPolicy && clientPolicy.imo && clientPolicy.imo.reBrand && props.user.demoStrategy && props.user.demoStrategy.reBrand === 2 && props.user.demoStrategy.reBrandLogo) {
                setReBrandLogo(LOGO_BASE_URL + props.user.demoStrategy.reBrandLogo);
            }
            if (props.user && props.user.demoStrategy && props.user.demoStrategy.reBrand === 1 && props.user.demoStrategy.reBrandLogo) {
                setReBrandLogo(LOGO_BASE_URL + props.user.demoStrategy.reBrandLogo);
            }
            if (user.role === 15) {
                let loggedInUser: any = user;
                let imo: null | any = null;
                if (loggedInUser.hasOwnProperty("ImoAdditionalMembers")) {
                    imo = loggedInUser.ImoAdditionalMembers && loggedInUser.ImoAdditionalMembers.imo;
                    if (imo && imo.reBrand && loggedInUser && loggedInUser.demoStrategy && loggedInUser.demoStrategy.reBrand === 2 && loggedInUser.demoStrategy.reBrandLogo) {
                        setReBrandLogo(LOGO_BASE_URL + props.user.demoStrategy.reBrandLogo);
                    }
                }
            }
        }

        if (props.user.accessType === "client" && (user.role === 1 || user.role === 2)) {
            if (user.demoStrategy && user.demoStrategy.reBrand && user.demoStrategy.slug === "kaizen") {
                setReBrandLogo(LOGO_BASE_URL + user.demoStrategy.reBrandLogo);
            }
        }
    }, [props.user]);

    return (
            <div key="roleBasedNavigation">
                {
                        (role === 4 || role === 3 || role === 1 || role === 2 || role === 15 || role === AccountType.Aggregator || role === AccountType.AggregatorMember) &&
                        accessType === "client" &&
                        <div key="clientNavigation">
                            <div className="logoWrap txtCenter ">
                                <div className="mt30">
                                    <img className="mt20" alt="Re Brand Logo" src={reBrandLogo || logoClient as string}/>
                                </div>
                                <Divider/>
                                <div className="clearFix"/>
                                <Typography variant="h5"> <img alt="" style={{ maxWidth: 200 }}
                                                               src={LOGO_BASE_URL + strategyLogo}/> <br/> Sponsored
                                    By</Typography>
                                <div className="clearFix"/>
                                {
                                    (role === 3 || role === 1 || role === 2 || role === 15 || role === AccountType.Aggregator || role === AccountType.AggregatorMember) && (user.demoStrategy && user.demoStrategy.reBrand && user.demoStrategy.slug === "kaizen") ?
                                            <Typography variant="h5" className="mt10">Company Logo Here</Typography> :
                                            ((role === 4 || role === 3 || role === 15) && !companyLogo) ?
                                                    <Typography variant="h5" className="mt10">Company Logo
                                                        Here</Typography> :
                                                    <img alt="" className="mt20 mb20 companyLogo"
                                                         src={companyLogo ? LOGO_BASE_URL + companyLogo : (user.demoLogo && (role === 1 || role === 2)) ? LOGO_BASE_URL + user.demoLogo : niwLogo as string}/>
                                }
                                <div className="clearFix"/>
                            </div>
                            <ClientNavigation user={props.user} handleNavClick={props.handleNavClick}
                                              SetIsEstimation={SetIsEstimation}/>
                        </div>
                }
                {
                        (role === 5 || role === 6) &&
                        <div key="clientNavigation">
                            <div className="logoWrap txtCenter ">
                                <img alt="" className="logo-" src={reBrandLogo || logoClient  as string}/>
                                <Divider/>
                                <div className="clearFix"/>
                                {
                                    !isServiceDashboardAccessible &&
                                        <>
                                            {
                                                (isNfIul) ?
                                                        <>
                                                            {
                                                                (strategyLogo) ?
                                                                        <>
                                                                            <img alt={strategyName}
                                                                                 src={LOGO_BASE_URL + strategyLogo} />
                                                                            <br />
                                                                            <Typography
                                                                                variant="h5">Sponsored By</Typography>
                                                                        </>
                                                                        :
                                                                        strategyName &&
                                                                        <Typography variant="h5"> <br /><strong>
                                                                            <StrategyName strategyName={strategyName} />
                                                                        </strong> <br /> Sponsored By </Typography>
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            <img alt={"Kai-Zen"}
                                                                 src={"https://niw-stage.s3.amazonaws.com/statregyLogo/XR2O5RX0.png"} />
                                                            <br />
                                                            <Typography variant="h5">Sponsored By</Typography>
                                                        </>
                                            }
                                    </>
                                //     <>
                                // {
                                //     (strategyLogo) ?
                                //             <>
                                //                 <img alt={strategyLogo} src={LOGO_BASE_URL + strategyLogo}/>
                                //                 <br/><Typography variant="h5">Sponsored By</Typography>
                                //             </>
                                //             :
                                //             strategyName &&
                                //             <Typography variant="h5"> <br/><strong> <StrategyName
                                //                     strategyName={strategyName}/> </strong>
                                //                 <br/>
                                //                 Sponsored By
                                //             </Typography>
                                // }
                                // </>
                            }
                                <div className="clearFix"/>
                                {
                                    !isServiceDashboardAccessible &&
                                <>
                                {
                                    companyLogo
                                            ? <img alt="" className="mt20 mb20" style={{ maxWidth: 200 }}
                                                   src={LOGO_BASE_URL + companyLogo}/>
                                            : (companyName)
                                                    ? <Typography variant="h5"><strong>{companyName}</strong></Typography>
                                                    : (reBrandLogo)
                                                            ? <img alt="" className="mt20 mb20" src={reBrandLogo}/>
                                                            : <Typography variant="h5">
                                                                <div className="clearFix"/>
                                                                <img alt="niwLogo" src={niwLogo as string}/>
                                                            </Typography>
                                }
                                </>
                                }
                                <div className="clearFix"/>
                            </div>
                            <ClientNavigation user={props.user} handleNavClick={props.handleNavClick}
                                              SetIsEstimation={SetIsEstimation} showLinks={!checkIsReviewDetailRoute(history.location)}/>
                        </div>
                }
                {
                        (role === 9 && accessType !== "client") &&
                        <div key="clientNavigation">
                            <div className="logoWrap txtCenter ">
                                <img alt="" className="logo" src={logoClient as string}/>
                                <Divider/>
                                <div className="clearFix"/>
                                <Typography variant="h5">
                                    {company &&
                                            <Typography variant="h5">{company.companyName}</Typography>
                                    }
                                </Typography>
                            </div>
                            <div className="clearFix"/>
                            <AssociationClientNavigation/>
                        </div>
                }
                {
                        (role === 12) &&
                        <div key="trustee avigation">
                            <img alt="" className="trustee logo" src={logoTrustee  as string}/>
                            <div className="clearFix"/>
                            <TrusteeNavigation handleNavClick={props.handleNavClick}/>
                        </div>
                }
                {
                        (role === 13) &&
                        <div key="bankNavigation">
                            <img alt="" className="bank logo" src={logoBank  as string}/>
                            <div className="clearFix"/>
                            <BankNavigation/>
                        </div>
                }
                {
                        ((role === 3 || role === 15) && accessType !== "client") &&
                        <div key="imoNavigation">
                            <img alt="" className="iMO logo" src={logoImo  as string}/>
                            <div className="clearFix"/>
                            <ImoNavigation handleNavClick={props.handleNavClick} role={role}/>
                        </div>
                }
                {
                    (role === 4 && accessType !== "client") && !isApprovedAgent &&
                            <div key="agentNavigation">
                                <img alt="" className="Agent logo" src={logoAgent as string} />
                                <div className="clearFix" />
                                <AgentNavigation handleNavClick={props.handleNavClick} />
                            </div>
                }
                {
                    (role === 4 && accessType !== "client") && isApprovedAgent &&
                            <div key="agentNavigation">
                                <img alt="" className="Agent logo approved" src={logoAgentApproved as string} />
                                <div className="clearFix" />
                                <AgentNavigation handleNavClick={props.handleNavClick} />
                            </div>
                }

                {
                        ((role === 2 || role === 1) && accessType !== "client") &&
                        <div key="adminNavigation">
                            <img alt="" className="Admin logo" src={logoAdmin  as string}/>
                            <div className="clearFix"/>
                            <AdminNavigation role={role} handleNavClick={props.handleNavClick}/>
                        </div>
                }

                {
                        role === 11 &&
                        <div key="clientNavigation">
                            <div className="logoWrap txtCenter ">
                                <img alt="" className="logo" src={reBrandLogo || logoClient  as string}/>
                                <Divider/>
                                <div className="clearFix"/>
                                {(props.user.groupLinkUser && props.user.groupLinkUser.groupLink) &&
                                        <Typography variant="h5">
                                            <strong>{props.user.groupLinkUser.groupLink.productName}</strong>
                                        </Typography>
                                }
                                <div className="clearFix"/>
                                <Typography variant="h5" align="center"><img alt=""
                                                                             className="mt20 mb20"
                                                                             src={pbg as string}/></Typography>
                                <div className="clearFix"/>
                            </div>
                        </div>
                }
                {
                        role === 8 &&
                        <div key="groupNavigation">
                            <img alt="" className="iMO logo" src={logoilia  as string}/>
                            <div className="clearFix"/>
                            <div className="groupName">
                                <Typography variant="body1" align="right"
                                            className="f14 mr15">{company && company.companyName}</Typography>
                            </div>

                            <div className="clearFix"/>
                            <GroupNavigation handleNavClick={props.handleNavClick}/>
                        </div>
                }
                {
                        role === 16 &&
                        <div key="groupNavigation">
                            <img alt="" className="iMO logo" src={logoilia as string}/>
                            <div className="clearFix"/>
                            <div className="groupName">
                                <Typography variant="body1" align="right"
                                            className="f14 mr15">{user && user.groupSigners && user.groupSigners.company.companyName} Signer</Typography>
                            </div>

                            <div className="clearFix"/>
                            <GroupNavigation handleNavClick={props.handleNavClick}/>
                        </div>
                }
                {
                        (role === AccountType.Carrier) &&
                        <div key="trusteeNavigation">
                            <img alt="" className="trustee logo" src={logoCarrier as string}/>
                            <div className="clearFix"/>
                            <CarrierNavigation handleNavClick={props.handleNavClick}/>
                        </div>
                }
                {
                        (role === AccountType.Aggregator || role === AccountType.AggregatorMember) && accessType !== "client" &&
                        <div key="aggregatorNavigation">
                            <img alt="" className="bank logo" src={logoAggregator as string}/>
                            <div className="clearFix"/>
                            <AggregatorNavigation
                                    handleNavClick={props.handleNavClick}
                                    aggregatorId={aggregatorId}
                            />
                        </div>
                }
            </div>
    );
}